let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9HmvL")).then(() => parcelRequire('fTMHw'));